export const GENERIC_PAYMENT_ERROR = 'Payment Error';

export const PAYMENT_METHODS = Object.freeze({
    ACH_DIRECT_DEBIT: 'achDirectDebit',
    ACH_BANK_TRANSFER: 'achBankTransfer',
    CREDIT_OR_DEBIT__CARD: 'creditOrDebitCard',
    CHECK: 'check'
});

export const PAYMENT_PROVIDER = Object.freeze({
    XPRESS_BILL_PAY: 'xpressbillpay',
    STRIPE: 'stripe',
});

export const PAYMENT_METHOD_LABELS = {
    CREDIT_OR_DEBIT__CARD: 'Card Processor Fee',
    CHECK: 'Check Processor Fee',
    ACH_DIRECT_DEBIT: 'Bank Processor Fee',
    ACH_BANK_TRANSFER: 'Bank Processor Fee'
};

export const CANCELLED_ALERT_MSG = 'Your transaction has been cancelled. Please enter valid payment details to try again.'
export const ACCOUNT_PICKER_CANCELLED_ALERT_MSG = 'You have cancelled the account verification process.';
export const ACCOUNT_PICKER_ERROR_ALERT_MSG = 'An error has occurred while verifying your bank account. Please try again with a different bank account.';
export const DEFAULT_ALERT_MSG = 'Payment Error';
export const PAY_ACH_ERROR = 'Payment processing for ACH payment methods are currently unavailable. Please try again at another time.'

export const REGISTRANT_OPTIONS = Object.freeze({
    OWNER: 'owner',
    PROPERTY_MANAGER: 'propertyManager',
    TENANT: 'tenant'
});

export const PROPERTY_MANAGEMENT_OPTIONS = Object.freeze({
    SELF_MANAGED: 'selfManaged',
    PROPERTY_MANAGER: 'propertyManager'
});

export const LOCAL_CONTACT_OPTIONS = Object.freeze({
    MYSELF: 'ownerRepMyself',
    PROPERTY_MANAGER: 'ownerRepPropertyManager',
    OWNER: 'ownerRepOwner',
    OTHER: 'ownerRepOther'
});